import React from 'react';
import styled from 'styled-components';
import { useScrollTo } from '../../Hooks';
import CallToActionPart from '../elements/CallToActionPart';
import CoverVideo from '../elements/CoverVideo';
import Circle from '../elements/Circle';
import backgroundImage from '../../assets/bg.png'; // Update the path to your image

const StyledHero = styled.section`
  position: relative;
  min-height: ${props => `calc(100vh - ${props.theme.navHeight})`};
  background: url(${backgroundImage}) no-repeat center center / cover;
`;

const Container = styled.div`
  width: 75%;
  min-height: 80vh;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    flex-direction: column-reverse;
    width: 90%;
    &>*:first-child {
      width: 100%;
      margin-top: 2rem;
    }
  }
`;

const Box = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

function Hero(setCollapseState) {
  const [elementId] = useScrollTo();
    const scrollToElement = (elId) => {
        if(!elId){
            return;
        }
        elementId(elId)
        setCollapseState(false);
    }
  return (
    <StyledHero id="intro">
      <Container>
        <Box>
          <CallToActionPart 
            btnText="Explore" 
            onClick={()=> scrollToElement("about")}
            mainTitle="Where Ideas Take Flight" 
            subTitle="Community of Learners" 
            typeWriterPhrases={[
              '<span class="text-1">AirEdify</span>', 
              '<span class="text-2">AirCompailer</span>', 
              '<span class="text-3">AirBuilder</span>'
            ]} 
          />
        </Box>
        <Box>
          <CoverVideo />
        </Box>
        <Circle />
      </Container>
    </StyledHero>
  );
}

export default Hero;
